import type { ComponentType, SVGProps } from 'react';
import { Icons } from '@/shared/components/ui/icons';

export type AppNavItem = {
  to: string;
  labelKey: string;
  descriptionKey?: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  exact?: boolean;
  superAdminOnly?: boolean;
};

/** @deprecated Use INTERNAL_NAV_ITEMS */
export type DashboardNavItem = AppNavItem;

/** Internal Super Admin navigation (elevated users). */
export const INTERNAL_NAV_ITEMS: AppNavItem[] = [
  { to: '/dashboard', labelKey: 'nav.dashboard', icon: Icons.Building, exact: true },
  {
    to: '/dashboard/products',
    labelKey: 'nav.products',
    descriptionKey: 'dashboard.modules.products',
    icon: Icons.Package,
  },
  {
    to: '/dashboard/plans',
    labelKey: 'nav.plans',
    descriptionKey: 'dashboard.modules.plans',
    icon: Icons.Layers,
  },
  {
    to: '/dashboard/monitor',
    labelKey: 'nav.monitor',
    descriptionKey: 'dashboard.modules.monitor',
    icon: Icons.BarChart,
    superAdminOnly: true,
  },
  {
    to: '/dashboard/trials',
    labelKey: 'nav.trials',
    descriptionKey: 'dashboard.modules.trials',
    icon: Icons.Timer,
  },
  {
    to: '/dashboard/payments',
    labelKey: 'nav.payments',
    descriptionKey: 'dashboard.modules.payments',
    icon: Icons.DollarSign,
    exact: true,
    superAdminOnly: true,
  },
  {
    to: '/dashboard/payments/instapay',
    labelKey: 'nav.paymentsInstapay',
    descriptionKey: 'dashboard.modules.paymentsInstapay',
    icon: Icons.Eye,
    superAdminOnly: true,
  },
  {
    to: '/dashboard/payments/myfatoorah',
    labelKey: 'nav.paymentsMyfatoorah',
    descriptionKey: 'dashboard.modules.paymentsMyfatoorah',
    icon: Icons.CheckCircle,
    superAdminOnly: true,
  },
  {
    to: '/dashboard/customer-messages',
    labelKey: 'nav.customerMessages',
    descriptionKey: 'dashboard.modules.customerMessages',
    icon: Icons.MessageSquare,
    superAdminOnly: true,
  },
  {
    to: '/dashboard/revenue-dashboard',
    labelKey: 'nav.revenueDashboard',
    descriptionKey: 'dashboard.modules.revenueDashboard',
    icon: Icons.BarChart,
    superAdminOnly: true,
  },
  {
    to: '/dashboard/analytics',
    labelKey: 'nav.analytics',
    descriptionKey: 'dashboard.modules.analytics',
    icon: Icons.BarChart,
    superAdminOnly: true,
  },
  {
    to: '/dashboard/analytics/platform-usage',
    labelKey: 'nav.platformUsage',
    descriptionKey: 'dashboard.modules.platformUsage',
    icon: Icons.Eye,
    superAdminOnly: true,
  },
  {
    to: '/dashboard/analytics/subscription-events',
    labelKey: 'nav.subscriptionEvents',
    descriptionKey: 'dashboard.modules.subscriptionEvents',
    icon: Icons.Repeat,
    superAdminOnly: true,
  },
];

/** @deprecated Use INTERNAL_NAV_ITEMS */
export const DASHBOARD_NAV_ITEMS = INTERNAL_NAV_ITEMS;

/** Customer Admin Portal navigation (tenant-bound users). */
export const PORTAL_NAV_ITEMS: AppNavItem[] = [
  {
    to: '/account',
    labelKey: 'portal.nav.overview',
    icon: Icons.Building,
    exact: true,
  },
  {
    to: '/account/subscription',
    labelKey: 'portal.nav.subscription',
    icon: Icons.Repeat,
  },
  {
    to: '/account/payments',
    labelKey: 'portal.nav.payments',
    icon: Icons.DollarSign,
  },
  {
    to: '/account/invoices',
    labelKey: 'portal.nav.invoices',
    icon: Icons.Tag,
  },
  {
    to: '/account/renew',
    labelKey: 'portal.nav.renew',
    icon: Icons.RefreshCw,
  },
  {
    to: '/account/upgrade',
    labelKey: 'portal.nav.upgrade',
    icon: Icons.Layers,
  },
  {
    to: '/account/company-profile',
    labelKey: 'portal.nav.companyProfile',
    icon: Icons.Users,
  },
];

export function getVisibleInternalNavItems(isSuperAdmin: boolean): AppNavItem[] {
  return INTERNAL_NAV_ITEMS.filter((item) => !item.superAdminOnly || isSuperAdmin);
}

/** @deprecated Use getVisibleInternalNavItems */
export function getVisibleNavItems(isSuperAdmin: boolean): AppNavItem[] {
  return getVisibleInternalNavItems(isSuperAdmin);
}
